// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TasksCreateForm from './data'

export default function TasksCreateFormFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TasksCreateForm">
      <TasksCreateForm {...props}>
        {children}
      </TasksCreateForm>
    </Flow>
  )
}
